// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3972":"f719af9b5c927815","4685":"3bc57a2f8508eb33"}[chunkId] + ".css";
};